import React from "react";
import personImage from "../assets/person.png"; 
import { FaCheck } from "react-icons/fa";

const WhoWeAre = () => {
  return (
    <section className="who-section">
    
      <div className="who-text">
        <h2>
        Transformamos <br />
          <span className="highlight">ideas en productos </span>
         <br></br> digitales que hacen<br></br> la diferencia.
        </h2>
        <p>
          Somos un <b>equipo capacitado</b> y <br></br> <b>obsesionado con la eficiencia e </b><br></br>
            innovación donde destacamos:
          
        </p>
        <ul>
      <li><FaCheck className="icon" /> +7 años de experiencia</li>
      <li><FaCheck className="icon" /> Soluciones escalables y seguras</li>
      <li><FaCheck className="icon" /> Tecnología con propósito</li>
    </ul>
      </div>

      {/* Contenedor de imagen */}
      <div className="who-image">
        <img src={personImage} alt="Equipo" />
        <span className="side-text">QUIÉNES <br/> SOMOS</span>
      </div>
    </section>
  );
};

export default WhoWeAre;